import request from '@/utils/request';

export function getShopCategoryList(query) {
  return request({
    url: '/api/system/shopCategory/queryShopCategoryList',
    method: 'post',
    data: query
  });
}

export function getItems(query) {
  return request({
    url: '/api/system/shopCategory/getItems',
    method: 'post',
    data: query
  });
}

export function getContent(query) {
  return request({
    url: '/api/system/shopCategory/getContent',
    method: 'post',
    data: query
  });
}

export function treeMenu(query) {
  return request({
    url: '/api/system/shopCategory/treeMenu',
    method: 'post',
    data: query
  })
}

export function getHomeOneCategory(query) {
  return request({
    url: '/api/system/shopCategory/getHomeOneCategory',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/category/index.js